module.exports = __webpack_public_path__ + "static/img/image_solutions_professional_02.776e6c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_professional_02.png
// module id = Vd6R
// module chunks = 10